<script setup lang="ts">
import { AppToast } from '@vinprop/design-system'
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView />

  <!-- Один контейнер на всё приложение: сообщения приходят из composable, а не
       от конкретного экрана — иначе отказ переноса на доске остался бы виден
       только как прыгнувшая обратно карточка. -->
  <AppToast />
</template>
